import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type EPRType = "EPIC" | "Cerner" | "CareFlow";

export const useEPRSettings = () => {
  return useQuery({
    queryKey: ["epr-settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("epr_settings")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) throw error;
      // Ensure we return a valid EPR type
      const eprType = data?.epr_type;
      if (eprType === "Cerner" || eprType === "CareFlow") {
        return eprType as EPRType;
      }
      return "EPIC" as EPRType;
    },
  });
};
